export default __webpack_public_path__ + "static/media/thumbnail.616e4605.webp";